$(document).ready(function () {
  
  $('.size-guide-link').on('click', function () {
    $('.size-guide').toggleClass('visible-content');
    $('.size-guide-container').toggleClass('visible-content');
  });
  $('.size-guide-container').on('click', function () {
    $(this).toggleClass('visible-content');
    $('.size-guide').toggleClass('visible-content');
  });

  $('.product-image .product-video').load();
  
  $('#ProductThumbs li a img').each(function(){
    var src_vid = $(this).closest('a').attr('data-video');
    
    if(typeof src_vid != 'undefined') {
      $('.product-image .product-video').find('source').attr('src',src_vid).load();
    }

    $(this).click(function(){
      var src_new = $(this).closest('a').attr('href');
      var src_vid = $(this).closest('a').attr('data-video');
      
      if(typeof src_vid != 'undefined') {
        $('.product-image .main-image').hide();
        $('.product-image .icon-external-link').hide();
        $('.zoomContainer').remove();
        $('.product-image .product-video').show();
        $('.product-image .product-video')[0].play();
      } else {
        $('.product-image .main-image').show().attr('src',src_new);
        $('.product-image .icon-external-link').show();
        $("#ProductPhotoImg").elevateZoom({ zoomType  : "inner", cursor: "crosshair" });
        $('.product-image .product-video').hide();
        $('.product-image .product-video')[0].pause();
        $('.product-image .product-video')[0].currentTime = 0;
      }
    });
  });

  /*$('.skip-search').click(function(e){
    e.preventDefault();
    
  	$(this).toggleClass('skip-active');
    $('#header-search').toggleClass('skip-active');
  });*/
  
  /*$('.skip-link').click(function(e){
    e.preventDefault();
  	$(this).toggleClass('skip-active');
  });*/

  
// Sign In drop down

$('.account-wrap a').click(function(e){
	e.preventDefault();
  
    /*$(this).toggleClass('skip-active');*/
    $('#CartDrawer').removeClass('skip-active');
    $('#header-search').removeClass('skip-active');
    $('#header-nav').removeClass('skip-active');
    
    $('#header-account').toggleClass('skip-active');
});
  
$('.header-minicart a').click(function(e){
    e.preventDefault();
  
    ajaxCart.load();
    /*$(this).toggleClass('skip-active');*/
    $('#header-search').removeClass('skip-active');
    $('#header-nav').removeClass('skip-active');
    $('#header-account').removeClass('skip-active');
  
    $('#CartDrawer').toggleClass('skip-active');
});
  
  
  $('.skip-search').click(function(e) {
    e.preventDefault();
    
    /*$(this).toggleClass('skip-active');*/
    $('#header-nav').removeClass('skip-active');
    $('#header-account').removeClass('skip-active');
    $('#CartDrawer').removeClass('skip-active');
    
    $('#header-search').toggleClass('skip-active');
  });

  $('.skip-nav').click(function(e) {
    e.preventDefault();
    
    /*$(this).toggleClass('skip-active');*/
    $('#header-account').removeClass('skip-active');
    $('#CartDrawer').removeClass('skip-active');
    $('#header-search').removeClass('skip-active');
    
    $('#header-nav').toggleClass('skip-active');
  });
  
  

  
});